import { theme } from '@prophecy/theme';
import { Spinner, Stack } from '@prophecy/ui-v3';

import { ConnectionsTab } from '../../Fabric/common/ConnectionsTab';
import { OrchestrationSecretTab } from '../../Fabric/secrets/OrchestrationSecretTab';
import { useWorkspaceFabricContext } from '../contexts/WorkspaceFabricContext/context';
import { SetupEnvironmentBanner } from './SetupEnvironment/SetupEnvironmentBanner';

const WorkspaceFabricTabContent = ({ tab }: { tab: 'connections' | 'secrets' }) => {
  const { allowEditFabric, formContexts, isAdmin, isFabricLoading } = useWorkspaceFabricContext();

  if (isFabricLoading) {
    return (
      <Stack align='center' alignY='center' height='100%' padding={theme.spaces.x32}>
        <Spinner spinning />
      </Stack>
    );
  }

  return (
    <Stack gap={theme.spaces.x16} height='100%'>
      <SetupEnvironmentBanner formContexts={formContexts} />

      {tab === 'connections' ? (
        <ConnectionsTab disabled={!allowEditFabric} formContexts={formContexts} isLoading={isFabricLoading} />
      ) : (
        <OrchestrationSecretTab isAdmin={isAdmin} />
      )}
    </Stack>
  );
};

export const WorkspaceFabricTabs = ({ tab }: { tab: 'connections' | 'secrets' }) => {
  return <WorkspaceFabricTabContent tab={tab} />;
};
